import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

/**
 * Hook for validating and correcting eNO1 files
 * @returns Mutation for validating eNO1 files
 */
export function useENO1Validate() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (fileId: number) => {
      const response = await axios.get(`/data-set/eno1/validate`, {
        params: {
          dataSet: fileId
        }
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate relevant queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['eno1Samples'] });
      queryClient.invalidateQueries({ queryKey: ['eno1FileDetails'] });
    }
  });
} 